import { Chip } from "@mui/material";
import React, { memo, useEffect, useState } from "react";

import Box from "../Box";
import TextField from "../TextField";
import Helpers from "../../commons/helpers";

interface Props {
    label?: string;
    required?: boolean;
    placeholder?: string;
    errorMessage?: string;
    defaultValue?: string[];
    variant?: "standard" | "outlined";
    onChangeValue?: (value: string[]) => void;
}

const InputListEmail: React.FC<Props> = (props: Props) => {
    const [value, setValue] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [listEmail, setListEmail] = useState<string[]>([]);
    const [selectedItem, setSelectedItem] = useState<number>(-1);

    useEffect(() => {
        setListEmail(props.defaultValue);
    }, [props.defaultValue]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>) => {
        const { key } = event.nativeEvent;
        if (key === " " || key === "Enter") {
            convertStringToListEmail();
        }
        if (value.length === 0 && key === "Backspace") {
            setSelectedItem(listEmail.length - 1);
            if (selectedItem !== -1) {
                handleDeleteItem(selectedItem);
            }
        }
    };

    const convertStringToListEmail = () => {
        setLoading(true);

        let listTemp = [...listEmail];
        value.split(" ").forEach(item => {
            if (!Helpers.isNullOrEmpty(item)) {
                const formatedItem = item.replace(",", "").replace(";", "");
                Helpers.isValidEmail(formatedItem) && listTemp.push(formatedItem);
            }
        });

        Helpers.isFunction(props.onChangeValue) && props.onChangeValue(listTemp);

        setValue("");
        setLoading(false);
    };

    const onChangeValue = (value: string) => {
        if (loading) return;
        setValue(value);
        if (selectedItem !== -1) {
            setSelectedItem(-1);
        }
    };

    const handleDeleteItem = (index: number) => {
        setLoading(true);

        const temp = [...listEmail];
        temp.splice(index, 1);

        Helpers.isFunction(props.onChangeValue) && props.onChangeValue(temp);

        setSelectedItem(-1);

        setLoading(false);
    };

    return (
        <Box>
            <Box mb={2}>
                {
                    listEmail.map((item, index) => (
                        <Chip
                            color="info"
                            label={item}
                            key={"chip_email_" + index}
                            sx={{ marginRight: "4px" }}
                            onDelete={() => handleDeleteItem(index)}
                        />
                    ))
                }
            </Box>
            <Box>
                <TextField
                    key={props.defaultValue as any || props.label}
                    fullWidth
                    multiline
                    label={props.label}
                    required={props.required}
                    placeholder={props.placeholder}
                    helperText={props.errorMessage}
                    InputLabelProps={{ shrink: true }}
                    variant={props.variant || "outlined"}
                    error={!Helpers.isNullOrEmpty(props.errorMessage)}

                    onKeyUp={handleKeyPress}
                    onBlur={(event: any) => convertStringToListEmail()}
                    onChange={(event: any) => onChangeValue(event.target.value)}
                />
            </Box>
        </Box>
    );
}

// Declaring default props for InputListEmail
InputListEmail.defaultProps = {
    label: "",
};

export default memo(InputListEmail);
